module.exports = __webpack_public_path__ + "images/2.1789545008192.jpg";